const DatenschutzPage = () => {
  return (
    <div data-testid="datenschutz-page">
      {/* Hero Section */}
      <section className="py-16 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-heading text-4xl sm:text-5xl font-bold uppercase tracking-tight text-slate-900">
            Datenschutzerklärung
          </h1>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="legal-content">
            <h2>1. Allgemeine Hinweise</h2>
            <p>
              Der Schutz Ihrer personenbezogenen Daten ist uns ein wichtiges Anliegen. 
              Wir behandeln Ihre Daten vertraulich und entsprechend den gesetzlichen 
              Datenschutzvorschriften sowie dieser Datenschutzerklärung.
            </p>

            <h2>2. Verantwortlicher</h2>
            <p>
              Pure Epox<br />
              Mehmet Semih Aytekin<br />
              Steubenstraße 23<br />
              35576 Wetzlar<br />
              Deutschland
            </p>
            <p>
              Telefon: <a href="tel:+4917672636169">+49 176 72636169</a><br />
              E-Mail: <a href="mailto:pureepox@gmail.com">pureepox@gmail.com</a>
            </p>

            <h2>3. Erhebung und Speicherung personenbezogener Daten</h2>
            <p>
              Personenbezogene Daten werden nur erhoben, wenn Sie uns diese freiwillig 
              mitteilen – beispielsweise über das Kontaktformular oder per E-Mail.
            </p>
            <p>Dabei können folgende Daten verarbeitet werden:</p>
            <ul>
              <li>Name</li>
              <li>Telefonnummer</li>
              <li>E-Mail-Adresse</li>
              <li>Nachrichtentext</li>
            </ul>
            <p>Die Verarbeitung erfolgt ausschließlich zur Bearbeitung Ihrer Anfrage.</p>
            <p>Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO.</p>

            <h2>4. Kontaktformular</h2>
            <p>
              Wenn Sie uns über das Kontaktformular kontaktieren, werden Ihre Angaben 
              inklusive der dort angegebenen Kontaktdaten gespeichert, um Ihre Anfrage zu bearbeiten.
            </p>
            <p>Eine Weitergabe an Dritte erfolgt nicht ohne Ihre ausdrückliche Einwilligung.</p>

            <h2>5. Hosting</h2>
            <p>
              Unsere Website wird bei einem externen Hosting-Dienstleister betrieben. 
              Dabei werden automatisch Informationen in sogenannten Server-Logfiles gespeichert, 
              die Ihr Browser automatisch übermittelt.
            </p>
            <p>Dies sind beispielsweise:</p>
            <ul>
              <li>IP-Adresse</li>
              <li>Browsertyp</li>
              <li>Datum und Uhrzeit der Serveranfrage</li>
            </ul>
            <p>Diese Daten dienen der technischen Sicherheit und Stabilität der Website.</p>
            <p>Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO.</p>

            <h2>6. Google Ads</h2>
            <p>Unsere Website kann über Google Ads beworben werden.</p>
            <p>
              Im Rahmen dieser Werbemaßnahmen kann es zur Verarbeitung personenbezogener 
              Daten durch Google kommen, insbesondere im Zusammenhang mit der Anzeige 
              und Auswertung von Werbung.
            </p>
            <p>Anbieter ist:</p>
            <p>
              Google Ireland Limited<br />
              Gordon House<br />
              Barrow Street<br />
              Dublin 4<br />
              Irland
            </p>
            <p>
              Weitere Informationen finden Sie unter:<br />
              <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
                https://policies.google.com/privacy
              </a>
            </p>

            <h2>7. SSL-Verschlüsselung</h2>
            <p>
              Diese Website nutzt aus Sicherheitsgründen eine SSL-Verschlüsselung. 
              Eine verschlüsselte Verbindung erkennen Sie an „https://" in der Adresszeile Ihres Browsers.
            </p>

            <h2>8. Ihre Rechte</h2>
            <p>Sie haben das Recht auf:</p>
            <ul>
              <li>Auskunft über Ihre gespeicherten Daten (Art. 15 DSGVO)</li>
              <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
              <li>Löschung Ihrer Daten (Art. 17 DSGVO)</li>
              <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
              <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
            </ul>

            <h2>9. Kontakt über WhatsApp</h2>
            <p>
              Wenn Sie über den WhatsApp-Button Kontakt mit uns aufnehmen, werden Sie direkt 
              zum Dienst WhatsApp weitergeleitet. Dabei können personenbezogene Daten 
              (z. B. Telefonnummer und Kommunikationsinhalte) an WhatsApp übermittelt werden.
            </p>
            <p>
              Anbieter ist WhatsApp Ireland Limited, 4 Grand Canal Square, Grand Canal Harbour, 
              Dublin 2, Irland.
            </p>
            <p>
              Bitte beachten Sie, dass wir keinen Einfluss auf die Datenverarbeitung durch 
              WhatsApp haben. Weitere Informationen finden Sie in der Datenschutzerklärung von WhatsApp:{" "}
              <a href="https://www.whatsapp.com/legal/privacy-policy-eea" target="_blank" rel="noopener noreferrer">
                https://www.whatsapp.com/legal/privacy-policy-eea
              </a>
            </p>
            <p>
              Die Nutzung von WhatsApp erfolgt auf freiwilliger Basis.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DatenschutzPage;
